var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"beian fl-center-al"},[_c('a',{attrs:{"href":"https://beian.miit.gov.cn/#/Integrated/index","target":"_blank","rel":"noopener noreferrer"}},[_c('span',[_vm._v("Copyright © 2024杭州嘉分科技有限公司 | 浙ICP备2024111770号-2")])])])])
}]

export { render, staticRenderFns }